import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LatestProperties.css';
import PropertyCard from '../PropertyCategory/PropertyCard';
import { propertyData } from '../../data/properties';

const LatestProperties = () => {
    const [activeTab, setActiveTab] = useState('Residential Plots');
    const navigate = useNavigate();

    // Map tab names to their routes
    const categoryRoutes: { [key: string]: string } = {
        'Residential Plots': '/residential-plots',
        'Individual Villas': '/villas',
        'Apartments': '/apartments',
        'Commercial Plots': '/commercial-plots',
        'Agriculture Lands': '/agricultural-lands',
        'Rentals': '/contact' // Assuming rentals might not have a specific page yet, or redirect to contact
    };

    const handleTabChange = (tab: string) => {
        setActiveTab(tab);
    };

    const handleViewMore = () => {
        const route = categoryRoutes[activeTab];
        if (route) {
            navigate(route);
            window.scrollTo(0, 0);
        }
    };

    const filteredProperties = propertyData.filter(item => item.category === activeTab);

    return (
        <section className="latest-properties">
            <h2 className="section-title">Explore Latest Properties</h2>

            {/* CATEGORY TABS */}
            <div className="property-tabs">
                {[
                    'Residential Plots',
                    'Individual Villas',
                    'Apartments',
                    'Commercial Plots',
                    'Agriculture Lands',
                    'Rentals'
                ].map(tab => (
                    <button
                        key={tab}
                        className={`tab ${activeTab === tab ? 'active' : ''}`}
                        onClick={() => handleTabChange(tab)}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            <div className="property-grid">
                {filteredProperties.map((property, index) => (
                    <PropertyCard
                        key={index}
                        image={property.image}
                        badgeSale={property.badgeSale}
                        badgeType={property.badgeType}
                        features={property.features}
                        title={property.title}
                        location={property.location}
                        price={property.price}
                        isCallPrice={property.isCallPrice}
                    />
                ))}
            </div>

            <div className="view-more">
                <button
                    className="view-more-btn"
                    onClick={handleViewMore}
                >
                    View More
                </button>
            </div>
        </section>
    );
};

export default LatestProperties;
